import * as PROJECT_CODE from '../../constants/projectCode';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import firebase from '../../lib/firebase.prod';

export async function GetAPSInfoFirebase() {
	var apsRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/helloSignDocumentInfo'
		)
		.child('APS');
	var apsInfo;

	await apsRef.once('value', (snapshot) => {
		apsInfo = snapshot.val();
	});

	return apsInfo;
}

export async function GetCondoDocInfoFirebase() {
	var condoDocRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/helloSignDocumentInfo'
		)
		.child('CONDODOC');
	var condoInfo;

	await condoDocRef.once('value', (snapshot) => {
		condoInfo = snapshot.val();
	});

	return condoInfo;
}

export async function GetETFFormInfoFirebase() {
	var eftRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/helloSignDocumentInfo'
		)
		.child('EFT');
	var eftInfo;

	await eftRef.once('value', (snapshot) => {
		eftInfo = snapshot.val();
	});

	return eftInfo;
}

export async function GetExtraDocumentInfoFirebase() {
	var extrasRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/helloSignDocumentInfo'
		)
		.child('extrasList');
	var extraInfo;

	await extrasRef.once('value', (snapshot) => {
		extraInfo = snapshot.val();
	});

	return extraInfo;
}

export function GetFirebaseDocumentInformation() {
	GetAPSInfoFirebase().then((returned) => {
		console.log(
			'GetFirebaseDocumentInformation Aps : ' + JSON.stringify(returned)
		);
		ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo = returned;
	});

	GetCondoDocInfoFirebase().then((returned) => {
		console.log(
			'GetFirebaseDocumentInformation Condo Doc : ' +
				JSON.stringify(returned)
		);
		ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo = returned;
	});

	GetETFFormInfoFirebase().then((returned) => {
		console.log(
			'GetFirebaseDocumentInformation EFT : ' + JSON.stringify(returned)
		);
		ALL_DOCUMENTS.allDocumentTypeInfo.eftFirebaseInfo = returned;
	});

	GetExtraDocumentInfoFirebase().then((returned) => {
		console.log(
			'GetFirebaseDocumentInformation Extra : ' + JSON.stringify(returned)
		);
		ALL_DOCUMENTS.allDocumentTypeInfo.extraDocumentInfo = returned;
	});

	ALL_DOCUMENTS.allDocumentTypeInfo.hasGottenInfo = true;
}
